/** Coordinator and worker agent descriptions (UI + validation). */
export const MAX_AGENT_DESCRIPTION_LENGTH = 2000;
/** Coordinator main prompt only. */
export const MAX_COORDINATOR_PROMPT_LENGTH = 10000;
/** Worker prompts and reminder prompts (coordinator + workers). */
export const MAX_AGENT_PROMPT_LENGTH = 5000;
/** Max synchronous worker agents in Virtual User MiniAgentConfigurator (matches Connector baseline). */
export const MAX_VIRTUAL_USER_SYNC_WORKERS = 5;
